import { Card, CardContent, Stack, TextField, Typography } from '@mui/material'
import ModalLoad from '../Modals/ModalLoad'
import { format } from 'date-fns'
import React, { useState } from 'react'
import { useReaderContext } from '../../../Contexts/Modules/ReaderModule/ReaderModule'
import StepHeader from './StepHeader'
import { stackGap } from '../../../Constants&Theme/Spacing'

function Step1Scan() {
  const { setBarcodes, setSourceBatch } = useReaderContext()
  const [manInput, setManInput] = useState('')
  return (
    <Card
      variant="outlined"
      sx={{ flex: 1.5 }}
    >
      <CardContent>
        <StepHeader
          step={1}
          name={'Scan'}
        />
        <Stack gap={stackGap.col}>
          <Typography variant="body2">
            Press load to import from memory, or scan to the field via
            bluetooth.
          </Typography>
          <Stack gap={1 / 2}>
            <ModalLoad />
            <TextField
              size={'small'}
              label={'Scan ID'}
              value={manInput}
              onChange={(e) => setManInput(e.target.value)}
              onKeyDown={(e: any) => {
                if (
                  e.key === 'Enter' ||
                  e.key === 'NumpadEnter' ||
                  e.key === 'Tab'
                ) {
                  setBarcodes((b: any) => ({
                    ...b,
                    [e.target.value.split(' ')[0]]: format(
                      new Date(),
                      'yyyy/MM/dd HH:mm:ss',
                    ),
                  }))
                  setSourceBatch(false)
                  setManInput('')
                }
              }}
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default Step1Scan
